import axios from 'axios'
import config from '../config'

export default {
    getEmailList(emailListId, currentPage, perPage) {
        return axios.get(config.publicPath + 'get-emails-list/' + emailListId,
            {
                params: {_page: currentPage, itemsPerPage: perPage},
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    addEmailsToList(formData) {
        return axios.post(config.publicPath + 'add-emails', formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },

    deleteEmail(id, formData) {
        return axios.post(config.publicPath + 'delete-emails-list/' + id, formData,
        {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },

    batchDeleteEmail(formData) {
        return axios.post(config.publicPath + 'batch-delete-emails', formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
